module.exports = __webpack_public_path__ + "img/Beanstalk.bdf2b713.png";